var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded==true)?_c('ModelPartForm',{attrs:{"glass_id":_vm.glass_id,"readOnly":false,"model_part":_vm.model_part}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }